export const noFormFieldsStyles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
		height: '100%'
	},

	searchIcon: {
		color: 'text.secondary',
		width: '145px',
		height: '145px',
		marginBottom: 3,
		marginTop: 3
	},

	noResults: {
		display: 'flex',
		textAlign: 'center',
		justifyContent: 'center',
		alignItems: 'center',
		fontSize: '1rem'
	},

	selectedFiltersMessage: {
		textAlign: 'center',
		maxWidth: '600px',
		margin: '0 auto'
	}
};
